// Bundled fallback so the prototype works even if the API is unreachable.
// Mirrors /api/feed exactly. Shape follows schemas/front-row-output.schema.json.
export const sampleFeed = {
  children: {
    hannah: { id: "hannah", name: "Hannah", initials: "HL", colorKey: "sage" },
  },
  events: [
    {
      event_id: "evt_choir_concert",
      event_name: "Choir Concert",
      display_headline: "Hannah · Choir Concert",
      event_family: "concert",
      children: ["hannah"],
      context: null,
      event_start: "2026-08-21T18:30:00+10:00",
      event_end: null,
      arrival_time: "2026-08-21T18:00:00+10:00",
      location: "Audrey Keown Theatre",
      parent_attendance: "expected",
      relevance: "relevant",
      actions: [
        {
          id: "act_choir_book",
          action_type: "BOOK",
          action_label: "Reserve Tickets",
          action_opens_at: "2026-02-01T08:00:00+11:00",
          action_due_at: null,
          action_url: "#",
          status: "outstanding",
        },
      ],
      updates: [
        {
          id: "upd_choir_open",
          classification: "meaningful",
          update_type: "booking_opened",
          summary: "Bookings opened today at 8:00 am.",
          received_at: "2026-02-07T08:00:00+11:00",
          changes_parent_plan: true,
          notify_parent: true,
        },
        {
          id: "upd_choir_venue",
          classification: "meaningful",
          update_type: "venue_changed",
          summary: "Venue moved to Audrey Keown Theatre.",
          received_at: "2026-02-05T10:00:00+11:00",
          changes_parent_plan: true,
          notify_parent: true,
        },
      ],
      resources: [
        { resource_type: "link", title: "Ticket booking page", url: "#", attachment_name: null },
        { resource_type: "attachment", title: "Concert programme", url: null, attachment_name: "program.pdf" },
      ],
    },
    {
      event_id: "evt_year5_camp",
      event_name: "Year 5 Camp",
      display_headline: "Hannah · Year 5 Camp",
      event_family: "camp",
      children: ["hannah"],
      context: null,
      event_start: "2026-09-15T09:00:00+10:00",
      event_end: "2026-09-17T15:00:00+10:00",
      arrival_time: null,
      location: "Point Wolstoncroft",
      parent_attendance: "not_required",
      relevance: "relevant",
      actions: [
        {
          id: "act_camp_consent",
          action_type: "CONSENT",
          action_label: "Complete Consent",
          action_opens_at: "2026-02-01T08:00:00+11:00",
          action_due_at: "2026-09-10T23:59:00+10:00",
          action_url: "#",
          status: "outstanding",
        },
      ],
      updates: [
        {
          id: "upd_camp_consent",
          classification: "meaningful",
          update_type: "action_required_added",
          summary: "Consent form is now available.",
          received_at: "2026-02-06T09:00:00+11:00",
          changes_parent_plan: true,
          notify_parent: true,
        },
      ],
      resources: [
        { resource_type: "attachment", title: "Camp information pack", url: null, attachment_name: "camp-info.pdf" },
        { resource_type: "attachment", title: "Packing list", url: null, attachment_name: "packing-list.pdf" },
      ],
    },
    {
      event_id: "evt_parent_interview",
      event_name: "Parent Interview",
      display_headline: "Hannah · Parent Interview",
      event_family: "parent_interview",
      children: ["hannah"],
      context: null,
      event_start: "2026-08-12T16:15:00+10:00",
      event_end: null,
      arrival_time: null,
      location: "Room 12B",
      parent_attendance: "expected",
      relevance: "relevant",
      actions: [
        {
          id: "act_interview_book",
          action_type: "BOOK",
          action_label: "Book Interview",
          action_opens_at: "2026-02-01T08:00:00+11:00",
          action_due_at: null,
          action_url: "#",
          status: "outstanding",
        },
      ],
      updates: [],
      resources: [
        { resource_type: "link", title: "Interview booking system", url: "#", attachment_name: null },
      ],
    },
    {
      event_id: "evt_year5_award",
      event_name: "Year 5 Assembly",
      display_headline: "Hannah · Year 5 Assembly — Award",
      event_family: "assembly",
      children: ["hannah"],
      context: "Award",
      event_start: "2026-08-28T09:00:00+10:00",
      event_end: null,
      arrival_time: null,
      location: "School Hall",
      parent_attendance: "invited",
      relevance: "relevant",
      actions: [],
      updates: [
        {
          id: "upd_award_selected",
          classification: "meaningful",
          update_type: "child_award",
          summary: "Hannah has been selected to receive an award.",
          received_at: "2026-02-07T14:30:00+11:00",
          changes_parent_plan: true,
          notify_parent: true,
        },
      ],
      resources: [],
    },
    {
      event_id: "evt_book_fair",
      event_name: "Book Fair Family Evening",
      display_headline: "Hannah · Book Fair Family Evening",
      event_family: "book_fair",
      children: ["hannah"],
      context: null,
      event_start: "2026-09-04T17:00:00+10:00",
      event_end: null,
      arrival_time: null,
      location: "Library",
      parent_attendance: "optional",
      relevance: "relevant",
      actions: [],
      updates: [],
      resources: [],
    },
    {
      event_id: "evt_grandparents_day",
      event_name: "Grandparents' Day",
      display_headline: "Hannah · Grandparents' Day",
      event_family: "grandparents_day",
      children: ["hannah"],
      context: null,
      event_start: "2026-10-22T10:00:00+10:00",
      event_end: null,
      arrival_time: null,
      location: "School Grounds",
      parent_attendance: "invited",
      relevance: "relevant",
      actions: [],
      updates: [],
      resources: [],
    },
    {
      event_id: "evt_speech_night",
      event_name: "Speech Night",
      display_headline: "Hannah · Speech Night",
      event_family: "speech_night",
      children: ["hannah"],
      context: null,
      event_start: "2026-12-04T19:00:00+10:00",
      event_end: null,
      arrival_time: null,
      location: "Town Hall",
      parent_attendance: "expected",
      relevance: "relevant",
      actions: [],
      updates: [],
      resources: [],
    },
  ],
};

// Defaults per canonical action_type (BOOK / RSVP / CONSENT / PAY / REGISTER).
// action_label always wins if present on the action itself.
export const ACTION_TYPE_DEFAULTS = {
  BOOK: { fallbackLabel: "Book", doneLabel: "Booked", doneToast: "Booked" },
  RSVP: { fallbackLabel: "RSVP", doneLabel: "RSVP'd", doneToast: "RSVP confirmed" },
  CONSENT: { fallbackLabel: "Complete Consent", doneLabel: "Submitted", doneToast: "Consent submitted" },
  PAY: { fallbackLabel: "Pay", doneLabel: "Paid", doneToast: "Payment recorded" },
  REGISTER: { fallbackLabel: "Register", doneLabel: "Registered", doneToast: "Registration recorded" },
};

export const DEFAULT_SETTINGS = {
  autoAddAfterAction: false,
  autoAddNoAction: true,
  askBeforeAdding: true,
  calendarProvider: "ask",
};